import { render, staticRenderFns } from "./videoConversionBadge.pug?vue&type=template&id=a4449df2&scoped=true&lang=pug&"
import script from "./VideoConversionBadge.vue?vue&type=script&lang=js&"
export * from "./VideoConversionBadge.vue?vue&type=script&lang=js&"
import style0 from "./VideoConversionBadge.vue?vue&type=style&index=0&id=a4449df2&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4449df2",
  null
  
)

/* custom blocks */
import block0 from "./VideoConversionBadge.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports